import { render, staticRenderFns } from "./combination_item.vue?vue&type=template&id=1a176718&scoped=true&"
import script from "./combination_item.vue?vue&type=script&lang=js&"
export * from "./combination_item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a176718",
  null
  
)

export default component.exports